import {
  EAccountType,
  fetchGetAgentInfo,
  IGetAgentInfoResponse200 as IRes200,
  IGetAgentInfoResponse400 as IRes400,
} from '../../../node/repositories/agent-card/v1/get-agent-info';
import { TThunkAction } from '../../types/redux';
import { setRealtorInfoFailure, setRealtorInfoRequest, setRealtorInfoSuccess } from './actions';
import { BadRequestError } from '@cian/valuation-utils-component';
import { CancellationToken } from '@cian/http-api';
import { HttpCancelError } from '@cian/peperrors/shared';
import { IRealtorData } from '../../types/realtorInfo';
import { IOfferInfo } from '../../models/realtorOffer';

export interface IGetRealtorInfoParams {
  realtorId: number;
  cancellationToken?: CancellationToken;
}

export const getRealtorInfo =
  (params: IGetRealtorInfoParams): TThunkAction<Promise<IRealtorData | undefined>> =>
  async (dispatch, getState, context) => {
    const { realtorId, cancellationToken } = params;
    const state = getState();
    const { httpApi, logger } = context;
    const {
      user: { userId },
    } = state;

    try {
      dispatch(setRealtorInfoRequest());
      const res = await fetchGetAgentInfo<IRes200, IRes400>({
        httpApi,
        parameters: {
          accountType: 'specialist' as EAccountType,
          id: realtorId,
          userId,
        },
        config: {
          cancellationToken,
        },
      });

      if (res.statusCode === 200) {
        const offers = (res.response.offers || []) as IOfferInfo[];

        const realtorData = {
          ...res.response,
          agent: { ...res.response.agent } as IRealtorData['agent'],
          offers: [...offers],
          reviews: { ...res.response.reviews } as IRealtorData['reviews'],
        };
        dispatch(setRealtorInfoSuccess(realtorData));

        return realtorData;
      } else {
        throw new BadRequestError({
          message: res.response.message,
          details: {
            errors: res.response.errors,
          },
          domain: 'getRealtorInfo.ts',
        });
      }
    } catch (e) {
      if (e instanceof HttpCancelError) {
        dispatch(setRealtorInfoSuccess(null));
      } else {
        dispatch(setRealtorInfoFailure());
      }

      if (!(e instanceof BadRequestError || e instanceof HttpCancelError)) {
        logger.error(e, {
          message: 'Ошибка при загрузке информации о риелторе',
          domain: 'getRealtorInfo.ts',
        });
      }

      return undefined;
    }
  };
